// extracted by mini-css-extract-plugin
module.exports = {"title":"e_Ekb","excerpt":"e_Fkb","container":"e_Gkb","imageContainer":"e_Hkb","image":"e_Ikb","postedBy":"e_Jkb","postedByDate":"e_Kkb"};